<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="$t('fixDutyFine.finalDetermination')"
    :visible.sync="visible"
    width="620px"
    @close="handleClose"
  >
    <div class="penalty-dialog-content">
      <!-- 顶部信息卡 -->
      <div class="info-block">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">{{ $t('fixDutyFine.selected') }}</span>
              <span class="info-value text-bold">
                {{ count }} {{ $t('fixDutyFine.ticketsUnit') }}
              </span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-item">
              <span class="info-label">{{ $t('base.billingMonth') }}</span>
              <span class="info-value">{{ month || '--' }}</span>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 免责/维持原定责 单选组 (对应接口 3 和 4) -->
      <div class="radio-group-block">
        <el-radio-group v-model="reviewType" class="custom-radio-group">
          <el-radio :label="3" class="custom-radio">
            <span class="radio-text">{{ $t('fixDutyFine.exempt') }}</span>
          </el-radio>
          <el-radio :label="4" class="custom-radio">
            <span class="radio-text">{{ $t('fixDutyFine.maintainOriginal') }}</span>
          </el-radio>
        </el-radio-group>
      </div>

      <!-- 审核意见输入框 -->
      <div class="textarea-block">
        <div class="required-label">{{ $t('fixDutyFine.reviewOpinion') }}</div>
        <el-input
          v-model="reviewOpinion"
          :placeholder="
            reviewType === 4
              ? $t('fixDutyFine.maintainOpinionPlaceholder')
              : $t('fixDutyFine.reviewOpinionPlaceholder')
          "
          :rows="4"
          maxlength="500"
          show-word-limit
          type="textarea"
        />
      </div>
    </div>

    <!-- 底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('fixDutyFine.cancel') }}</el-button>
      <el-button :loading="submitting" type="success" @click="handleSubmit">{{ $t('fixDutyFine.confirmDetermination') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
// 引入真实的最终定责接口
import { lmReconciliationFinalDetermination } from '@/api/definiteResponsibilityAndPenalty';

export default {
  name: 'FinalDeterminationDialog',
  data() {
    return {
      count: 0,
      visible: false,
      reviewType: 3, // 默认选择免责 (3=免责, 4=维持原定责)
      reviewOpinion: '', // 审核意见
      submitting: false,
      currentRecord: {},
      mode: 'single',
      month: ''
    };
  },
  methods: {
    // 暴露给父组件的方法：打开弹窗
    open(record) {
      const isArray = Array.isArray(record);
      if ((isArray && record.length === 0) || (!isArray && Object.keys(record).length === 0)) {
        this.$message.warning(this.$t('fixDutyFine.selectDeterminationRecords'));
        return;
      }
      // 3. 根据类型分别处理，确保后续逻辑稳定
      if (isArray) {
        // 如果是数组（批量处理），强制 mode 为 batch
        this.currentRecord = record;
        this.mode = 'batch';
        this.count = record.length; // 自动计算数量，防止外面传错
        // 4. 设置月份和重置表单状态
        this.month = this.currentRecord[0].reconciliationPeriod;
      } else {
        // 如果是对象（单个处理），强制 mode 为 single
        this.currentRecord = record;
        this.mode = 'single';
        this.count = 1; // 单个就是 1
        // 4. 设置月份和重置表单状态
        this.month = this.currentRecord.reconciliationPeriod;
      }
      this.reviewType = 3; // 默认免责
      this.reviewOpinion = '';
      this.submitting = false;
      this.visible = true;
    },

    // 提取需要提交的 ids
    getTargetIds() {
      if (Array.isArray(this.currentRecord)) {
        return this.currentRecord.map((item) => item.id).filter((id) => id !== undefined);
      } else if (this.currentRecord && this.currentRecord.id) {
        return [this.currentRecord.id];
      }
      return [];
    },

    async handleSubmit() {
      // 校验：如果是“维持原定责”(4)，审核意见必填
      if (this.reviewType === 4 && !this.reviewOpinion.trim()) {
        this.$message.warning(this.$t('fixDutyFine.maintainOpinionRequired'));
        return;
      }

      // 组装与后端一一对应的 payload
      const payload = {
        ids: this.getTargetIds(),
        reviewType: this.reviewType, // 3 或 4
        reviewOpinion: this.reviewOpinion.trim() // 维持原定责时必填，免责时传空字符串或按需传值
      };

      if (payload.ids.length === 0) {
        this.$message.error(this.$t('fixDutyFine.invalidWaybillId'));
        return;
      }

      this.submitting = true;
      try {
        // 调用后端接口
        const res = await lmReconciliationFinalDetermination(payload);

        if (res.code === 200) {
          this.$message.success(this.$t('fixDutyFine.determinationSuccess'));
          this.submitting = false;
          this.close();
          // 通知父组件刷新列表
          this.$emit('submit-success', payload);
        } else {
          this.$message.error(res.msg || this.$t('fixDutyFine.determinationFailed'));
          this.submitting = false;
        }
      } catch (error) {
        console.error('最终定责接口异常', error);
        this.$message.error(this.$t('fixDutyFine.networkError'));
        this.submitting = false;
      }
    },

    close() {
      this.visible = false;
      this.submitting = false;
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.penalty-dialog-content {
  padding: 0 10px;
}

/* 顶部信息卡样式 */
.info-block {
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 15px 20px;
  margin-bottom: 20px;

  .info-item {
    display: flex;
    flex-direction: column;

    .info-label {
      font-size: 12px;
      color: #909399;
      margin-bottom: 6px;
    }

    .info-value {
      font-size: 14px;
      color: #303133;
      font-weight: bold;

      &.text-bold {
        color: #303133;
      }
    }
  }
}

/* 单选按钮组样式 (还原UI图大小和边框) */
.radio-group-block {
  margin-bottom: 20px;

  .custom-radio-group {
    display: flex;
    justify-content: space-between;
    width: 100%;

    ::v-deep .el-radio {
      width: 48%;
      margin-right: 0;
      border: 1px solid #dcdfe6;
      border-radius: 6px;
      padding: 15px 20px;
      text-align: center;
      background: #fff;
      transition: all 0.3s;

      .el-radio__label {
        font-size: 15px;
        font-weight: 500;
        color: #303133;
        padding-left: 8px;
      }

      &.is-checked {
        border-color: #00b050;
        background-color: #f0f9eb; // 浅绿色背景
        box-shadow: 0 0 0 1px #00b050 inset;
      }

      &.is-checked .el-radio__label {
        color: #303133;
      }
    }
  }
}

/* 审核意见必填红色星号 */
.required-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: 500;

  .red-star {
    color: #f56c6c;
    margin-right: 4px;
  }
}

/* 文本域样式 */
.textarea-block {
  ::v-deep .el-textarea__inner {
    border-radius: 6px;
    padding: 12px;
  }
}

/* 底部按钮样式 */
.dialog-footer {
  text-align: right;

  .el-button--success {
    background-color: #00b050;
    border-color: #00b050;

    &:hover,
    &:focus {
      background-color: #009146;
      border-color: #009146;
    }
  }
}
</style>
